"use client";

import { motion } from "framer-motion";

/**
 * Subtelna animacja wejścia dla listy/kategorii blogu — działa zarówno
 * przy wchodzeniu z innych stron jak i po kliknięciu „Powrót do bloga".
 */
export default function BlogIndexTemplate({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
